'use strict'

const $ = window.jQuery
const $icons = $('.js-notifications-icon');
const ACTIVE_CLASS_NAME = 'is-active'

exports.recordRead = function (loanId) {
	if (!loanId) {
		return
	}

	$.post(`/loans/updates/read/${loanId}`, res => {
		if(!res.hasUnreadNotifications) {
			hasNotifications(false)
		}
	})
}

function hasNotifications (has) {
	const method = has
		? 'addClass'
		: 'removeClass'

	$icons[method](ACTIVE_CLASS_NAME)
}